import React from 'react';
import { useParams } from 'react-router-dom';

import { CollectionsWalletList } from '../../components';
import { useFetchCollectionsWallets } from '../../hooks/queries';
import { WalletTransactions } from './wallets-transactions';
import { useHasPermission } from '../../hooks';
import { PERMISSIONS } from '../../config';

function Wallets({ getCardExtra, headerSlot }) {
  const hasPermission = useHasPermission();
  const canViewBalance = hasPermission(PERMISSIONS.BALANCE_VIEW);

  if (!canViewBalance) return null;

  const { wallets } = useFetchCollectionsWallets();
  const { id } = useParams();

  return (
    <div className="wallets-page">
      {headerSlot}
      <CollectionsWalletList getCardExtra={getCardExtra} />

      <WalletTransactions wallets={wallets} currencyId={id} />
    </div>
  );
}

export { Wallets };
